// repo/primary-care-connect/frontend/src/pages/Portal/ClinicAdmin/ClinicProfile/sections/ClinicIdentitySection.tsx

import React from "react";

type ClinicIdentity = {
  clinicId: number;
  governanceStatus?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export default function ClinicIdentitySection(props: {
  clinic: ClinicIdentity;
  formatDateTime: (val: string | null | undefined) => string;
}) {
  const { clinic, formatDateTime } = props;

  return (
    <div className="ca-clinic-profile__panel">
      <div className="ca-clinic-profile__sectionTitle">Clinic identity</div>

      <div className="ca-clinic-profile__row">
        <div className="ca-clinic-profile__label">Clinic ID</div>
        <div className="ca-clinic-profile__value">{clinic.clinicId}</div>
      </div>

      <div className="ca-clinic-profile__row">
        <div className="ca-clinic-profile__label">Governance status</div>
        <div className="ca-clinic-profile__value">
          {clinic.governanceStatus || "—"}
        </div>
      </div>

      <div className="ca-clinic-profile__row">
        <div className="ca-clinic-profile__label">Created</div>
        <div className="ca-clinic-profile__value" style={{ color: "#6b7a94" }}>
          {formatDateTime(clinic.createdAt)}
        </div>
      </div>

      <div className="ca-clinic-profile__row">
        <div className="ca-clinic-profile__label">Last updated</div>
        <div className="ca-clinic-profile__value" style={{ color: "#6b7a94" }}>
          {formatDateTime(clinic.updatedAt)}
        </div>
      </div>
    </div>
  );
}
